import React, {Component} from "react";
import {
    Table,
    Dropdown
} from "react-bootstrap";
import { viewSurvey, findStaffByName, listAllPeerStaffFeedbackReport, listLocations } from "../../../actions";
import "./../ReportsPage/ReportsPage.scss";
import Spinner from "react-spinner";
import "react-spinner/react-spinner.css";
import {connect} from "react-redux"; 
import PaginationArea from "./../../Utilities/PaginationArea";
import dateFormat from "dateformat";
import DayPicker from 'react-day-picker';
import DayPickerInput from 'react-day-picker/DayPickerInput';
// Include the locale utils designed for moment
import MomentLocaleUtils, {formatDate, parseDate} from 'react-day-picker/moment';
// Make sure moment.js has the required locale data
import 'moment/locale/es';
import 'react-day-picker/lib/style.css';
import ExportCSV from './../../Utilities/ExportCSV';
import StaffProfileMenuItem from './../../Utilities/StaffProfileMenuItem.js';
import {asyncContainer, Typeahead} from 'react-bootstrap-typeahead';
const AsyncTypeahead = asyncContainer(Typeahead);


class PeerWrittenStaffFeedbackReport extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            perpage: 20,
            filter: '',
            sort: null,
            sortDirection: 'desc',
            currentFilter: 8,
            activeKey: 1,
            dateFilter: 'thismonth',
            locationFilter: 0,
            currentFilterName: '  This Month (' + new Date().toLocaleString('en-us', { month: 'long' }) + ') ',
            currentFilterLocation: ' All Locations ',
            showCustomDate: false,
            showLocations: true,
            reportFrom: null,
            reportTo: null,
            searchoptions: [],
            isLoading:false
        };

          this.selectStaffFromSearch = this.selectStaffFromSearch.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleFromChange = this.handleFromChange.bind(this);
        this.handleToChange = this.handleToChange.bind(this);
        this.runReport = this.runReport.bind(this);     

        this.props.listLocations(this.props.tvClient).then(()=>{
          if(this.props.isLocationOnly){
                    if(this.props.roleLocations!==undefined){
                        var newLocation = null;
                        var newLocationName = '';
                        for(var i=0; i<this.props.roleLocations.length;i++){
                            newLocation = this.props.roleLocations[i];
                            break;
                        }
                        if(newLocation!==null){
                            for (var i = this.props.locations.length - 1; i >= 0; i--) {
                              if(this.props.locations[i].location_id.toString()===newLocation.toString()){
                                    newLocationName = ' ' + this.props.locations[i].name + ' ';     
                                    break;
                              }
                            }
                        }
                        if(newLocation!==null && newLocationName!==''){
                            this.setState({ locationFilter: newLocation, currentFilterLocation: newLocationName }, ()=>{
                                this.changeListPage(1);
                            });     
                        }
                    } 
                } 
        });

    }   


    handleFromChange(from) {
      this.setState({ reportFrom: from });
    }
    handleToChange(to) {
      this.setState({ reportTo: to });
    }   

    viewSurvey(id){
        this.props.viewSurvey(this.props.tvClient, id);
    }    

    runReport(){
      this.setState({ dateFilter: 'custom', currentFilter: 6, currentFilterName: ' Date Range (' + dateFormat(this.state.reportFrom, "shortDate") + ' to ' + dateFormat(this.state.reportTo, "shortDate") + ') ' });
      //this.props.viewAdminDashboardEndorsementsReports(this.props.accessToken, this.state.locationFilter, 'custom', dateFormat(this.state.reportFrom, "shortDate"), dateFormat(this.state.reportTo, "shortDate"));
      this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, 1, this.state.perpage, this.state.locationFilter, 'custom', dateFormat(this.state.reportFrom, "shortDate"), dateFormat(this.state.reportTo, "shortDate"));
    } 

    handleLocationFilter(selectedKey){
      if(parseInt(selectedKey)===0){
        this.setState({ locationFilter: 0, currentFilterLocation: ' All Locations '});
        if(this.state.dateFilter==='custom'){
            this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, 1, this.state.perpage, 0, this.state.dateFilter, dateFormat(this.state.reportFrom, "shortDate"), dateFormat(this.state.reportTo, "shortDate"));    
        } else{
            this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, 1, this.state.perpage, 0, this.state.dateFilter, null, null);    
        }
        
      }
      else{
        for (var i = this.props.locations.length - 1; i >= 0; i--) {
          if(this.props.locations[i].location_id===parseInt(selectedKey)){
            this.setState({ locationFilter: selectedKey, currentFilterLocation: ' ' + this.props.locations[i].name + ' ' });
            if(this.state.dateFilter==='custom'){
                this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, 1, this.state.perpage, selectedKey, this.state.dateFilter, dateFormat(this.state.reportFrom, "shortDate"), dateFormat(this.state.reportTo, "shortDate"));    
            } else{
                this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, 1, this.state.perpage, selectedKey, this.state.dateFilter, null, null);    
            }
            
            break;
          }
        }
        
      }
    }

    handleFilter(selectedKey) {
      if(selectedKey==1){
        this.setState({ dateFilter: 'alltime', showCustomDate: false, currentFilter: selectedKey, currentFilterName: ' All Time ' }, () => {
          this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, 1, this.state.perpage, this.state.locationFilter, this.state.dateFilter, null, null);
        });
      } else if(selectedKey==2){
        this.setState({ dateFilter: 'thismonth', showCustomDate: false, currentFilter: selectedKey, currentFilterName: ' This Month (' + new Date().toLocaleString('en-us', { month: 'long' }) + ') ' }, () => {
          this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, 1, this.state.perpage, this.state.locationFilter, this.state.dateFilter, null, null);
        });
      } else if(selectedKey==3){
        this.setState({ dateFilter: 'lastmonth', showCustomDate: false, currentFilter: selectedKey, currentFilterName: ' Last Month (' + new Date(new Date().getFullYear(), new Date().getMonth()-1).toLocaleString('en-us', { month: 'long' }) + ') ' }, () => {
          this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, 1, this.state.perpage, this.state.locationFilter, this.state.dateFilter, null,null);
        });
      } else if(selectedKey==4){
        this.setState({ dateFilter: 'yeartodate', showCustomDate: false, currentFilter: selectedKey, currentFilterName: ' Year To Date (' + new Date().toLocaleString('en-us', { year: 'numeric' }) + ') ' }, () => {
          this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, 1, this.state.perpage, this.state.locationFilter, this.state.dateFilter, null, null);
        });
      } else if(selectedKey==5){
        this.setState({ dateFilter: 'lastyear', showCustomDate: false, currentFilter: selectedKey, currentFilterName: ' Last Year (' + new Date(new Date().getFullYear()-1, 1).toLocaleString('en-us', { year: 'numeric' }) + ') ' } , () => {
          this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, 1, this.state.perpage, this.state.locationFilter, this.state.dateFilter, null, null);
        });
      } else if(selectedKey==6){
        this.setState({ showCustomDate: true });
      }
      if(selectedKey==8){
        this.setState({ dateFilter: 'alltime', showCustomDate: false, currentFilterName: ' All Time ', currentFilter: selectedKey }, () => {
          this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, 1, this.state.perpage, this.state.locationFilter, this.state.dateFilter, null, null);
        });
        
      }
    }

    handleSearch(query) {
          this.setState({isLoading: true});
          this.props.findStaffByName(this.props.tvClient.accessToken, query).then((staff)=>{
            this.setState({isLoading: false, searchoptions: staff });
          })
    }

    removeStaffFilter(){
      this.typeahead.clear();
      this.setState({filter: ''}, () => {
        this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, 1, this.state.perpage, 0, this.state.dateFilter, dateFormat(this.state.reportFrom, "shortDate"), dateFormat(this.state.reportTo, "shortDate"));      
      });
    }

    selectStaffFromSearch(person) {
      if(person[0]!==undefined){
        this.setState({ filter: person[0].staff_id }, () => {
          this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, 1, this.state.perpage, 0, this.state.dateFilter, dateFormat(this.state.reportFrom, "shortDate"), dateFormat(this.state.reportTo, "shortDate"));      
        });
      }
    } 

    componentDidMount() {
        if(!this.props.isLocationOnly){
          this.changeListPage(1);  
        }
        
    }

    changeListPage(page) {
        if(this.state.dateFilter==='custom'){
            this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, page, this.state.perpage, this.state.locationFilter, this.state.dateFilter, dateFormat(this.state.reportFrom, "shortDate"), dateFormat(this.state.reportTo, "shortDate"));
        } else{
            this.props.listAllPeerStaffFeedbackReport(this.props.tvClient, 'and', this.state.filter, this.state.sort, page, this.state.perpage, this.state.locationFilter, this.state.dateFilter, null, null);            
        }
        
    }

    render() {
       return <div>
            <h1 className="page-header">
                Written Staff Feedback

            <div className="row float-right filterRow">
              <div className="col-md-3">

                    <div className="float-right">
                      <label htmlFor="filterSurvey">Choose a Date:</label>

                        <Dropdown
                          title='Filter Report By Date'
                          id='filterSurvey'
                          drop="down" onSelect={this.handleFilter.bind(this)}
                        >
                          <Dropdown.Toggle className="btn-default" id="dropdown-basic">
                            Filter Report By Date
                          </Dropdown.Toggle>
                          <Dropdown.Menu>  
                          <Dropdown.Item eventKey="1">All Time</Dropdown.Item>
                          <Dropdown.Item eventKey="2">This Month</Dropdown.Item>
                          <Dropdown.Item eventKey="3">Last Month</Dropdown.Item>
                          <Dropdown.Item eventKey="4">YTD</Dropdown.Item>
                          <Dropdown.Item eventKey="5">Last Year</Dropdown.Item>
                          <Dropdown.Item eventKey="6">Custom</Dropdown.Item>
                          <Dropdown.Divider/>
                          <Dropdown.Item eventKey="8">Reset Filter</Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>

              {this.state.showCustomDate && <div className="customDateRange">
                  <p className="prizeDrawTitle">Select the range to run the report for:</p>
                  <label className="dayPickerLabel">From:</label><DayPickerInput formatDate={formatDate} id="fromDate" name="fromDate" onDayChange={this.handleFromChange}
                    dayPickerProps={{
                      selectedDays: this.state.selectedDay,
                      disabledDays: {
                        after: new Date(),
                      },
                    }} />

                <label className="dayPickerLabel">To:</label><DayPickerInput formatDate={formatDate} id="toDate" name="toDate" onDayChange={this.handleToChange}
                    dayPickerProps={{
                      selectedDays: this.state.selectedDay,
                      disabledDays: {
                        after: new Date(),
                        before: this.state.prizeFrom
                      },
                    }} />

              <button className="btn btn-primary" onClick={this.runReport}>{this.props.runningReport ? 'Running...' : 'Run Report'}</button>
              </div>
            }

              </div>

              <div className="col-md-3">
                    {(this.state.showLocations && this.props.locations) && <div className="customLocationRange">
                          <label htmlFor="filterSurvey">Choose a Location:</label>
                            <Dropdown
                              title='Choose a Location'
                              id='filterSurvey'
                              drop="down" onSelect={this.handleLocationFilter.bind(this)}
                            >
                              <Dropdown.Toggle className="btn-default" id="dropdown-basic">
                                {this.state.currentFilterLocation}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>  
                      
                            {!this.props.isLocationOnly && <Dropdown.Item eventKey={0}>All Locations</Dropdown.Item>}
                              {Object.values(this.props.locations).map(d => {
                                  if(this.props.isLocationOnly){
                                      if(this.props.roleLocations!==undefined){
                                          for(var i=0; i<this.props.roleLocations.length;i++){
                                              if(this.props.roleLocations[i].toString()===d.location_id.toString()){
                                                  return  <Dropdown.Item eventKey={d.location_id} key={d.location_id}>{d.name}</Dropdown.Item>
                                              }
                                          }
                                      } else{
                                          return  <Dropdown.Item eventKey={d.location_id} key={d.location_id}>{d.name}</Dropdown.Item>    
                                      }
                                  } else{
                                      return  <Dropdown.Item eventKey={d.location_id} key={d.location_id}>{d.name}</Dropdown.Item>    
                                  }
                                
                              })}
                              </Dropdown.Menu>
                            </Dropdown>
                    </div> }   

              </div>
              
              <div className="col-md-3 lastOne">

                  <div>
                      <div>
                        <label htmlFor="searchByNameInput">Search Results By Name:{this.state.filter!=='' && <a className="removeStaffFilter" onClick={this.removeStaffFilter.bind(this)}><h3> (Reset)</h3></a>}</label>
                        
                     <AsyncTypeahead
                     id="searchByNameInput"
                      isLoading={this.state.isLoading}
                       labelKey="name"
                      onSearch={this.handleSearch}
                      onChange={this.selectStaffFromSearch}
                      options={this.state.searchoptions} 
                      placeholder="Search"
                      ref={(typeahead) => this.typeahead = typeahead}
                      renderMenuItemChildren={(option, props) => (
                        <StaffProfileMenuItem key={option.staff_id} user={option} />
                      )}
                    /> 
                      </div>
                  </div>

              </div>

            </div>


            </h1>
                        
            <p className="case-list-container stand-out-line float-right">Showing data for <span className="text-underline">{this.state.currentFilterName}</span> at <span className="text-underline">{this.state.currentFilterLocation}</span></p>

            <div className="case-list-container">
                {  this.props.staffFeedbackData && <Table className="case-list sortable reportBadgeContainer">
                    <thead>
                    <tr className="reportBadgeContainer table-headings">
                        <th scope="col">Name</th>
                        <th scope="col">Feedback</th>
                        <th scope="col">Badge Count</th>
                        <th scope="col" className="text-center">Date</th>
                        <th scope="col" className="text-center">Survey Link</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.props.staffFeedbackData.map((c,index) => {
                            return <tr className="surveyRow statDeptContainer reportBadgeContainer" onClick={()=> this.viewSurvey(c.survey_id)} key={index}>
                                <td>{c.response.name}</td>
                                <td>{c.response.feedback}</td>
                                <td className="text-center">{c.response.badges!==undefined ? c.response.badges.length : '0'}</td>
                                <td className="text-center">{dateFormat(c.created, "shortDate")}</td>
                                <td className="text-center totalTdValue">View Survey</td>
                            </tr>
                        })
                    }
                    </tbody>
                </Table> 
              
                }
                <div className="float-right">
                  <ExportCSV csvData={this.props.exportStaffFeedbackData} fileName={"StaffFeedback-" + this.state.currentFilterLocation.trim() + ".csv"} />
              </div>
              {(!this.props.staffFeedbackDataLoading && this.props.staffFeedbackData.length===0) && <p className="text-center">No Results Found</p>}
                {this.props.staffFeedbackDataLoading && <Spinner/>}
                <PaginationArea currentPage={this.props.paginationInfo.current_page} parentRefresh={this.changeListPage.bind(this)} numberOfPages={this.props.paginationInfo.num_pages} items={this.props.paginationItems} />           

            </div>    

        </div> 
    }
}

const mapStateToProps = state => {
    return {
        tvClient: state.login.tvClient,
        accessToken: state.login.tvClient.accessToken,
        staffFeedbackDataLoading: state.staffPeerFeedbackData.loading,
        staffFeedbackData: state.staffPeerFeedbackData.staffFeedbackData,
        exportStaffFeedbackData: state.staffPeerFeedbackData.exportStaffFeedbackData,
        paginationInfo: state.staffPeerFeedbackData.paginationInfo,
        paginationItems: state.staffPeerFeedbackData.paginationInfo.pageList,
        locations: state.locationList.locations,
        isLocationOnly: state.login.user && state.login.user.attributes.role === 'locationonly',
        roleLocations: state.login.user.attributes.locations
    };
};

const mapDispatchToProps = dispatch => {
    return {        
        listLocations: (...params) => dispatch(listLocations(...params)),
        findStaffByName: (...params) => dispatch(findStaffByName(...params)),
        listAllPeerStaffFeedbackReport: (...params) => dispatch(listAllPeerStaffFeedbackReport(...params)),
        viewSurvey: (...params) => dispatch(viewSurvey(...params))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PeerWrittenStaffFeedbackReport);
